import { render, staticRenderFns } from "./WhatsAppCTA.vue?vue&type=template&id=10985e71&scoped=true&"
import script from "./WhatsAppCTA.vue?vue&type=script&lang=js&"
export * from "./WhatsAppCTA.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppCTA.vue?vue&type=style&index=0&id=10985e71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10985e71",
  null
  
)

export default component.exports